// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2Cmez","rootSmall":"AddTileButton_rootSmall__1zEDL"};